import { createStandardAction } from 'typesafe-actions';
import { IADICategory } from '../../api/adiCategories/adiCategories';
import { VideoType } from './types';

const setBusinessCategory = createStandardAction(
  'VIDEO_INFO/SET_BUSINESS_CATEGORY',
)<IADICategory | undefined>();
const setBusinessName = createStandardAction('VIDEO_INFO/SET_BUSINESS_NAME')<
  string | undefined
>();
const setVideoPurpose = createStandardAction('VIDEO_INFO/SET_VIDEO_PURPOSE')<
  string | undefined
>();
const setVideoType = createStandardAction('VIDEO_INFO/SET_VIDEO_TYPE')<
  VideoType | undefined
>();
const setPersonalCategory = createStandardAction(
  'VIDEO_INFO/SET_PERSONAL_CATEGORY',
)<IADICategory | undefined>();

export {
  setBusinessCategory,
  setBusinessName,
  setVideoPurpose,
  setVideoType,
  setPersonalCategory,
};
